import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export const store = new Vuex.Store ({
    state: {
        creditVal: 0,
        kontoVal: 0,
        sollzins: 0,
        sollzinsAmount: 0,
        liqProv: 0,
        liqProvAmount: 0
    },
    getters: {
        getCredit(state) {
            return state.creditVal
        },
        getKonto(state) {
            return state.kontoVal
        },
        getSollzins (state) {
            return state.sollzins
        },
        getLiqProv (state) {
            return state.liqProv
        },
        getSollzinsAmount (state) {
            return state.sollzinsAmount
        },
        getLiqProvAmount (state) {
            return state.LiqProvAmount
        }
    },
    mutations: {
        updateCredit (state, payload) {
            state.creditVal = payload
        },
        updateKonto (state, payload) {
            state.kontoVal = payload
        },
        updateSollzins(state, payload) {
            state.sollzins = payload
        },
        calculateSollzins(state, payload) {
            state.sollzinsAmount = payload
        },
        updateLiqProv (state, payload) {
            state.liqProv = payload
        }
    }
})